import React, { useState, useEffect } from 'react';
import { Typography, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const styles: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
};

const crossmarkStyle: React.CSSProperties = {
  fontSize: 100,
  color: 'red', // You can use your desired color here
};

const PaymentFailedPage: React.FC = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState<number>(10);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prevCountdown) => prevCountdown - 1);
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  useEffect(() => {
    if (countdown === 0) {
      const searchParams = new URLSearchParams(window.location.search);
      const loc = searchParams.get("loc");
      if(loc === 'card' ){
        navigate('/');
      }else{
        navigate(-2);
      }
    }
  }, [countdown, navigate]);

  return (
    <div style={styles}>
<div style={crossmarkStyle}>&#10008;</div>
      <Typography variant="h5">Payment Failed</Typography>
      <Typography variant="h6">Please try your transaction again</Typography>
      <Typography variant="subtitle1">
        Redirecting in {countdown} seconds...
      </Typography>
      <CircularProgress />
    </div>
  );
};

export default PaymentFailedPage;
